<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
        <img :src="logoUrl" v-if="logoUrl" />
        <img src="@assets/images/logo2.png" v-else />
      </div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="list">
        <div class="item">
          <div class="acea-row row-between-wrapper">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-phone_"></use>
            </svg>
            <input type="text" placeholder="输入手机号码" v-model="mobile" />
          </div>
        </div>
        <div class="item">
          <div class="align-left">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-code_1"></use>
            </svg>
            <input
              type="text"
              placeholder="填写验证码"
              class="codeIput"
              v-model="code"
            />
            <button
              class="code"
              :disabled="disabled"
              :class="disabled === true ? 'on' : ''"
              @click="codes"
            >
              {{ text }}
            </button>
          </div>
        </div>
      </div>
      <div class="logon" @click="loginMobile">登录</div>
    </div>
    <div class="bottom"></div>
  </div>
</template>
<style>
.register .whiteBg {
  padding-bottom: 0.3rem;
}
</style>
<script>
import sendVerifyCode from "@mixins/SendVerifyCode";
import { login, registerVerify } from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
import cookie from "@utils/store/cookie";
import { mapGetters } from "vuex";

const BACK_URL = "login_back_url";

export default {
  name: "Login",
  mixins: [sendVerifyCode],
  data: function() {
    return {
      navList: ["账号登录", "快速登录"],
      current: 1,
      mobile: "",
      password: "",
      code: "",
      formItem: 1,
      type: "login",
      logoUrl: ""
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  mounted() {
    if (this.userInfo["id"]) {
      const backUrl = cookie.get(BACK_URL) || "/";
      cookie.remove(BACK_URL);
      console.log("backUrl-login", backUrl);
      this.$router.replace({ path: backUrl });
    }
  },
  methods: {
    async loginMobile() {
      var that = this;
      const { mobile, code } = that;
      try {
        await that
          .$validator({
            mobile: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            code: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ]
          })
          .validate({ mobile, code });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      login({
        ...this.userInfo,
        mobile: that.mobile,
        code
      })
        .then(res => {
          that.$store.commit("UPDATE_USERINFO", res.data);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(res => {
          that.$dialog.error(res);
        });
    },
    async register() {
      var that = this;
      const { mobile, code, password } = that;
      try {
        await that
          .$validator({
            mobile: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ],
            code: [
              required(required.message("验证码")),
              alpha_num(alpha_num.message("验证码"))
            ],
            password: [
              required(required.message("密码")),
              attrs.range([6, 16], attrs.range.message("密码")),
              alpha_num(alpha_num.message("密码"))
            ]
          })
          .validate({ mobile, code, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }
      login({
        ...this.userInfo,
        mobile: that.mobile,
        code: that.code,
        password: that.password,
        action: "add"
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.formItem = 1;
          that.$store.commit("UPDATE_USERINFO", res.data);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          that.$router.replace({ path: backUrl });
        })
        .catch(err => {
          that.$dialog.error(err);
        });
    },
    async codes() {
      var that = this;
      const { mobile } = that;
      try {
        await that
          .$validator({
            mobile: [
              required(required.message("手机号码")),
              chs_phone(chs_phone.message())
            ]
          })
          .validate({ mobile });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      await registerVerify({
        mobile: that.mobile,
        type: "register"
      })
        .then(res => {
          that.$dialog.success(res.msg);
          that.sendCode();
        })
        .catch(err => {
          that.$dialog.error(err);
        });
    },
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
      const { mobile, password } = this;
      try {
        await this.$validator({
          mobile: [
            required(required.message("账号")),
            attrs.range([5, 16], attrs.range.message("账号")),
            alpha_num(alpha_num.message("账号"))
          ],
          password: [
            required(required.message("密码")),
            attrs.range([6, 16], attrs.range.message("密码")),
            alpha_num(alpha_num.message("密码"))
          ]
        }).validate({ mobile, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ ...this.userInfo, mobile, password })
        .then(({ data }) => {
          this.$store.commit("UPDATE_USERINFO", data);
          const backUrl = cookie.get(BACK_URL) || "/";
          cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
        })
        .catch(e => {
          this.$dialog.error(e);
        });
    }
  }
};
</script>
